











































import Proxyable from '@/mixins/proxyable';
import {
  WorkflowFormField,
  WorkflowFormFieldType,
  WorkflowFormSectionField,
  IWorkflowFormFieldType,
  IWorkflowFormSection,
  WorkflowFormFieldTypeEnum
} from '@/models';
import { ErrorManager } from '@/models/error';
import { PropType } from 'vue';
import { mapActions } from 'vuex';

import ErrorAlert from '@/components/common/ErrorAlert.vue';

export default Proxyable.extend({
  name: 'WorkflowFormBuilderSectionFieldsDrawer',

  components: { ErrorAlert },

  props: {
    value: Object as PropType<IWorkflowFormSection>,
    fieldDrawer: Boolean,
    templateId: Number,
    parentFieldId: Number
  },

  data() {
    return {
      loading: false,

      errorMessage: '',
      detailErrorMessage: '',
      WorkflowFormFieldTypeEnum
    };
  },

  computed: {
    drawer: {
      get(): boolean {
        return this.fieldDrawer;
      },
      set(value: boolean) {
        this.$emit('update:fieldDrawer', value);
      }
    },

    fieldTypes(): IWorkflowFormFieldType[] {
      return WorkflowFormFieldType.getWorkflowFormFieldTypeList();
    }
  },

  methods: {
    ...mapActions({
      createWorkflowFormField: 'workflowFormTemplate/createWorkflowFormField'
    }),

    addField(fieldTemplateId: number) {
      const field = new WorkflowFormSectionField({
        order: this.internalValue.section_fields.length!,
        width: 12,
        field_template: fieldTemplateId,
        required: false,
        disabled: false,
        create_todo: false,
        constraints: []
      });

      this.internalValue.section_fields.push(field);

      this.save();
    },

    createNewField(type: IWorkflowFormFieldType) {
      this.clearAllErrors();
      this.loading = true;

      const payload = new WorkflowFormField({
        label: `${type.text} field`,
        hint: '',
        type: type.value,
        meta_label: '',
        template: this.parentFieldId || null
      });

      this.createWorkflowFormField(payload)
        .then(data => {
          this.addField(data.id);
        })
        .catch(error => {
          if (error.response) {
            if (error.response.data.detail) {
              this.errorMessage = error.response.data.detail;
            }
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    save() {
      this.$emit('save');
      this.close();
    },

    close() {
      this.drawer = false;
    },

    clearAllErrors() {
      this.errorMessage = '';
      this.detailErrorMessage = '';
    }
  }
});
